import Vue from 'vue'
import Antd from 'ant-design-vue'
import { Icon } from 'ant-design-vue'
import '../antd-variables.less'
const IconFont = Icon.createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_627750_xddxoezg57.js'
})
Vue.component('IconFont', IconFont)
Vue.use(Antd)
